import type { ButtonHTMLAttributes, ReactNode } from 'react';

export type Tone = 'neutral' | 'ok' | 'warn' | 'bad';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & { variant?: 'primary' | 'secondary' | 'danger' | 'ghost' };

export function Button({ variant = 'secondary', className = '', ...props }: ButtonProps) {
  const styles: Record<NonNullable<ButtonProps['variant']>, string> = {
    primary: 'bg-gold text-shell-900 hover:bg-gold/90',
    secondary: 'bg-shell-700 text-white hover:bg-shell-500',
    danger: 'bg-bad text-white hover:bg-bad/90',
    ghost: 'bg-transparent text-white/80 hover:text-white',
  };
  return <button type="button" {...props} className={`touch rounded-xl px-5 text-base font-semibold disabled:opacity-40 ${styles[variant]} ${className}`} />;
}

export function ErrorNote({ children }: { children: ReactNode }) {
  return (
    <p role="alert" className="rounded-lg border border-bad/40 bg-bad/20 px-3 py-2 text-sm text-white">
      {children}
    </p>
  );
}

export function FullPageMessage({ title, detail, tone }: { title: string; detail?: string; tone?: Tone }) {
  return (
    <div className="grid min-h-full place-items-center p-8">
      <div className="max-w-md text-center">
        <p className={`text-lg font-medium ${tone === 'bad' ? 'text-bad' : 'text-white'}`}>{title}</p>
        {detail ? <p className="mt-2 text-sm text-white/60">{detail}</p> : null}
      </div>
    </div>
  );
}
